/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var UnknownIcon = createIcon("UnknownIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 8c8.837 0 16 7.163 16 16s-7.163 16-16 16S8 32.837 8 24 15.163 8 24 8Zm0 2c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14-6.268-14-14-14Zm0 20 .163.009a1.5 1.5 0 11-.326 0L24 30Zm4.872-11.122a5 5 0 01-3.205 5.837 1 1 0 00-.657.804l-.01.14V27a1 1 0 01-1.99.136L23 27v-1.34a3 3 0 011.793-2.749L25 22.83a3 3 0 10-3.992-3.045L21 20a1 1 0 11-2 0 5 5 0 019.872-1.122Z",
    fill: "#171717"
  }));
}, {
  "i18nKey": "svg.UnknownIcon"
});